import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { SessionService } from '@empathyco/x-utils'

import type { ActionContext } from 'vuex'

import type { ActionClass, TaggingState, TaggingViewPayload } from '../../../models'
import type { TaggingService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { CONFIG_CONSTS } from '../../config/config.consts'

export class TagViewAction implements ActionClass {
  static execute(
    this: void,
    { rootGetters }: ActionContext<TaggingState, any>,
    payload: TaggingViewPayload,
  ): Promise<void> {
    const taggingService = CONTAINER.get<TaggingService>(TYPES.TaggingService)
    const instanceConfig: Instance =
      rootGetters[`${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.currentInstance}`]
    const sessionId = CONTAINER.get<SessionService>(TYPES.SessionService).getSessionId()
    return taggingService.tagView(instanceConfig.id, payload, sessionId)
  }
}
